/* @flow */
import type {SearchQueryResponseData} from '../queries/searchQuery';

export const SEARCH_QUERY_COMPLETE = 'SEARCH_QUERY/COMPLETE';
export const SEARCH_QUERY_START = 'SEARCH_QUERY/START';

type SearchQueryStartActionType = 'SEARCH_QUERY/START';
type SearchQueryCompleteActionType = 'SEARCH_QUERY/COMPLETE';

type SearchQueryStartPayloadType = {
    data: SearchQueryResponseData,
    prevData: SearchQueryResponseData
};

export type SearchQueryCompleteAction = {
    type: SearchQueryCompleteActionType,
    payload: SearchQueryResponseData
};

export type SearchQueryStartAction = {
    type: SearchQueryStartActionType,
    payload: SearchQueryStartPayloadType
};

export type Action = SearchQueryCompleteAction | SearchQueryStartAction;

const ACTION_CREATORS = {
    searchQueryComplete(
        data: SearchQueryResponseData
    ): SearchQueryCompleteAction {
        return {
            type: SEARCH_QUERY_COMPLETE,
            payload: data
        };
    },
    searchQueryStart(
        payload: SearchQueryStartPayloadType
    ): SearchQueryStartAction {
        return {
            type: SEARCH_QUERY_START,
            payload
        };
    }
};

export default {...ACTION_CREATORS};
